module.exports = __webpack_public_path__ + "static/media/2.aca18183.jpg";